var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyCourses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-courses"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645",
    "data-name": "Rectangle 2645",
    width: 16,
    height: 16,
    transform: "translate(39 264)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_333",
    "data-name": "Mask Group 333",
    transform: "translate(-39 -264)",
    clipPath: "url(#my-courses)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_11_",
    "data-name": "svgexport-6 (11)",
    transform: "translate(39 265.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8201",
    "data-name": "Path 8201",
    d: "M8.691,6.484a.313.313,0,1,0-.312-.312A.313.313,0,0,0,8.691,6.484Zm0,0",
    transform: "translate(0.559 0.391)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8202",
    "data-name": "Path 8202",
    d: "M8.691,8.242a.313.313,0,1,0-.312-.312A.313.313,0,0,0,8.691,8.242Zm0,0",
    transform: "translate(0.559 0.508)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M2.656,4.727a.313.313,0,1,0-.313-.312A.313.313,0,0,0,2.656,4.727Zm0,0",
    transform: "translate(0.156 0.273)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8204",
    "data-name": "Path 8204",
    d: "M2.656,6.484a.313.313,0,1,0-.313-.312A.313.313,0,0,0,2.656,6.484Zm0,0",
    transform: "translate(0.156 0.391)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8205",
    "data-name": "Path 8205",
    d: "M2.656,8.242a.313.313,0,1,0-.313-.312A.313.313,0,0,0,2.656,8.242Zm0,0",
    transform: "translate(0.156 0.508)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8206",
    "data-name": "Path 8206",
    d: "M15.688,1.25H14.75V.313A.312.312,0,0,0,14.438,0H9.25A1.561,1.561,0,0,0,8,.626,1.561,1.561,0,0,0,6.75,0H1.563A.312.312,0,0,0,1.25.313V1.25H.313A.312.312,0,0,0,0,1.563V12.188a.312.312,0,0,0,.313.313H5.978a.933.933,0,0,1,.839.518,1.323,1.323,0,0,0,2.368,0,.933.933,0,0,1,.839-.518h5.665A.312.312,0,0,0,16,12.188V1.563a.312.312,0,0,0-.312-.313ZM9.25.625h4.875v10H9.25a1.555,1.555,0,0,0-.937.313V1.563A.939.939,0,0,1,9.25.625Zm-5.5,0H5v1.6l-.452-.3a.312.312,0,0,0-.347,0l-.452.3Zm-1.875,0h1.25V2.813a.312.312,0,0,0,.486.26l.764-.509.764.509a.312.312,0,0,0,.486-.26V.625H6.75a.939.939,0,0,1,.938.938v9.376a1.554,1.554,0,0,0-.938-.313H1.875Zm13.5,11.25H10.022a1.555,1.555,0,0,0-1.4.864.7.7,0,0,1-1.25,0,1.555,1.555,0,0,0-1.4-.864H.625v-10H1.25v9.063a.312.312,0,0,0,.313.313H6.75a.939.939,0,0,1,.938.938.313.313,0,0,0,.625,0,.939.939,0,0,1,.938-.938h5.188a.312.312,0,0,0,.313-.313V1.875h.625Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8207",
    "data-name": "Path 8207",
    d: "M8.691,4.844h3.938a.312.312,0,0,0,.313-.312V2.656a.312.312,0,0,0-.312-.313H8.691a.312.312,0,0,0-.312.313V4.531A.312.312,0,0,0,8.691,4.844ZM9,2.969h3.313v1.25H9Zm0,0",
    transform: "translate(0.559 0.156)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8208",
    "data-name": "Path 8208",
    d: "M3.828,4.727H6.516a.313.313,0,1,0,0-.625H3.828a.313.313,0,1,0,0,.625Zm0,0",
    transform: "translate(0.234 0.273)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8209",
    "data-name": "Path 8209",
    d: "M3.828,6.484H6.516a.313.313,0,1,0,0-.625H3.828a.313.313,0,1,0,0,.625Zm0,0",
    transform: "translate(0.234 0.391)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8210",
    "data-name": "Path 8210",
    d: "M3.828,8.242H6.516a.313.313,0,1,0,0-.625H3.828a.313.313,0,1,0,0,.625Zm0,0",
    transform: "translate(0.234 0.508)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8211",
    "data-name": "Path 8211",
    d: "M12.551,5.859H9.863a.313.313,0,1,0,0,.625h2.688a.313.313,0,0,0,0-.625Zm0,0",
    transform: "translate(0.637 0.391)",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8212",
    "data-name": "Path 8212",
    d: "M12.551,7.617H9.863a.313.313,0,1,0,0,.625h2.688a.313.313,0,0,0,0-.625Zm0,0",
    transform: "translate(0.637 0.508)",
    fill: "#8391a2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCourses);
export default __webpack_public_path__ + "static/media/my-courses.c3cf0a2c9bdeaba2b6dd1ec33c50facb.svg";
export { ForwardRef as ReactComponent };